// removed by extract-text-webpack-plugin
module.exports = {"wrap-category-menu":"wrap-category-menu","title-category":"title-category","view-more-link":"view-more-link","category-menu":"category-menu","view-more-category":"view-more-category","category-menu-item":"category-menu-item","item":"item","item-link":"item-link","category-sub-menu":"category-sub-menu"};


//////////////////
// WEBPACK FOOTER
// ./components/category/_CategoryMenu.scss
// module id = ./components/category/_CategoryMenu.scss
// module chunks = 0